module.exports = __webpack_public_path__ + "static/img/2025年历-11.39c1d00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-11.png
// module id = 4hCA
// module chunks = 3